// index
export const PROGRAM_HEADER_TO_INDEX_MAP = {
    amazonStore: 0,
    program1: 1,
    inventoryPlacedIn1: 3,
    program2: 4,
    inventoryPlacedIn2: 6,
    storageSeason: 7
};

export const ITEM_HEADER_TO_INDEX_MAP = {
    sku: 0,
    fnsku: 1,
    asin: 2,
    productName: 3,
    feeCategory: 4,
    longestSide: 5,
    medianSide: 6,
    shortestSide: 7,
    unitOfDimension: 8,
    itemPackageWeight: 9,
    unitOfWeight: 10,
    price: 11,
    currency: 12,
    costOfGoodsSold: 13,
    shippingToAmazon: 14,
    averageInventoryUnitsStored: 15,
    estimatedMonthlyUnitsSold: 16,
    estimatedSales: 17,
    mfnFulfillmentCostPerUnit: 18, // MFN input
    mfnMonthlyStorageCostPerUnit: 19, // MFN input
    mfnDeliveryCharge: 20,
    miscellaneousCost: 21,
    isInventoryPlacementChosen: 22,
    isOpaqueBaggingChosen: 23,
    isTapingChosen: 24,
    isLabellingChosen: 25,
    isPolyBaggingChosen: 26,
    isBubbleWrapChosen: 27
};


export const PROGRAM_DATA_INDEX = 1;
export const PROGRAM_DATA_LENGTH = 8;
export const ITEM_HEADER_INDEX = 2;
export const ITEM_DATA_LENGTH = 28;
export const MAX_ITEM_COLUMN_VAL = 23;